import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Checkbox from 'material-ui/Checkbox';
import Toggle from 'material-ui/Toggle';
import Card from 'material-ui/Card';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import * as _ from 'lodash';
import { assignTeamMemberToOrganization, unassignTeamMemberFromOrganization, editClientDetail, getClient, getWhitelabelInfo, getPartnerDetailsByPartnerOrgId, getTeamMembers, selectItem, deselectItem, toggleAllSelected } from 'redux/modules/teamManagement';
import { refreshFacebookToken } from 'redux/modules/socialConnection';
import { addOrganizationTab, clearOrgBillingConfig, fetchOrganization, getOrgBillingConfig, getOrgNotificationSubscriptions, upsertAvailableFeatures } from 'redux/modules/organization';
import { getAdsPaymentMethod, getAdSpendSummaryForOrganization, clearCreditCardInfo, getBillingHistory } from 'redux/modules/billing';
import Helmet from 'react-helmet';
import moment from 'moment';
import { LeftNavLayout, AdminFacebookPageManager } from 'containers';
import tallyClientTotals from '../../../helpers/newClientSummaryTotals';
import NewClientSummary from 'containers/Admin/NewClient/NewClientSummary';
import { BillingHistoryTable, ButtonBar, CheckboxList, ControlBar, Control, ModalTopBar, PageHeader, QueueFlyoutTab, Spinner, EmptyState, Invoice } from 'components';
import { BillingDetail, ClientDetailForm, ClientDetailReportList, PendingAffiliateClient, TeamNotificationTab } from 'containers/Admin';
import NewLocationSummary from '../NewLocation/NewLocationSummary';
import ClientFeatureSettings from 'components/ClientFeatureSettings/ClientFeatureSettings';
import * as styles from './ClientDetail.scss';
var ClientDetail = (_dec = connect(function (state, props) {
  var _state$organization, _state$organization$s;

  var orgId = props.clientId;
  return {
    user: state.auth.user,
    billingHistory: state.billing.billingHistoryByOrgId && state.billing.billingHistoryByOrgId[orgId] ? state.billing.billingHistoryByOrgId[orgId] : [],
    hasAdPaymentMethod: state.billing.hasAdPaymentMethod,
    cc: state.billing.cc,
    heartbeat: state.billing.adSpendHeartbeat,
    organization: state.organization.current,
    clientDetail: state.teamManagement.clientDetailById && state.teamManagement.clientDetailById[orgId] ? state.teamManagement.clientDetailById[orgId] : null,
    loadingPartnerDetails: state.teamManagement.loadingPartnerDetails,
    partnerDetailsById: state.teamManagement.partnerDetailsById,
    partnerDetails: state.teamManagement.partnerDetails,
    isAssigning: state.teamManagement.isAssigning,
    isUnassigning: state.teamManagement.isUnassigning,
    isLoadingClient: state.teamManagement.isLoadingClient,
    isLoadingClients: state.teamManagement.isLoadingClients,
    orgBillingConfig: state.organization.orgBillingConfigById && state.organization.orgBillingConfigById[orgId] ? state.organization.orgBillingConfigById[orgId] : null,
    editingClient: state.teamManagement.editingClient,
    selectedAssignedTeamMembers: state.teamManagement.selectedAssignedTeamMembers,
    selectedUnassignedTeamMembers: state.teamManagement.selectedUnassignedTeamMembers,
    teamMembers: state.teamManagement.teamMembers,
    whiteLabelById: state.teamManagement.whiteLabelById,
    theme: state.theme,
    loadingClientErrorMessage: state.teamManagement.loadingClientErrorMessage,
    selectedOrgData: state !== null && state !== void 0 && (_state$organization = state.organization) !== null && _state$organization !== void 0 && (_state$organization$s = _state$organization.selectedOrgDetails) !== null && _state$organization$s !== void 0 && _state$organization$s[orgId] ? state.organization.selectedOrgDetails[orgId] : null
  };
}, {
  addOrganizationTab: addOrganizationTab,
  assignTeamMemberToOrganization: assignTeamMemberToOrganization,
  clearOrgBillingConfig: clearOrgBillingConfig,
  clearCreditCardInfo: clearCreditCardInfo,
  deselectItem: deselectItem,
  editClientDetail: editClientDetail,
  fetchOrganization: fetchOrganization,
  getAdsPaymentMethod: getAdsPaymentMethod,
  getAdSpendSummaryForOrganization: getAdSpendSummaryForOrganization,
  getClient: getClient,
  getOrgBillingConfig: getOrgBillingConfig,
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId,
  getTeamMembers: getTeamMembers,
  getWhitelabelInfo: getWhitelabelInfo,
  refreshFacebookToken: refreshFacebookToken,
  selectItem: selectItem,
  toggleAllSelected: toggleAllSelected,
  unassignTeamMemberFromOrganization: unassignTeamMemberFromOrganization,
  getBillingHistory: getBillingHistory,
  getOrgNotificationSubscriptions: getOrgNotificationSubscriptions,
  upsertAvailableFeatures: upsertAvailableFeatures
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ClientDetail, _Component);

  var _super = _createSuper(ClientDetail);

  function ClientDetail(props) {
    var _this;

    _classCallCheck(this, ClientDetail);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTeamMemberButtonBarChange", function (tab) {
      _this.setState({
        selectedTeamMemberView: tab.key
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenTab", function (orgId) {
      var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'schedule';
      return _this.props.fetchOrganization(orgId).then(function (result) {
        _this.props.addOrganizationTab(result.data);

        browserHistory.push("/org/".concat(orgId, "/").concat(link));
      })["catch"](function (err) {
        return console.error(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleBusinessModal", function () {
      _this.setState({
        showBusinessModal: !_this.state.showBusinessModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleBillingModal", function () {
      _this.setState({
        showBillingModal: !_this.state.showBillingModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowClick", function (selectedRow) {
      var clickedId;

      if (_this.state.selectedTab === 2) {
        clickedId = _this.props.clientDetail.teamMembers[selectedRow].id;
      } else if (_this.state.selectedTab === 3) {
        var filteredTeamMemberList = [];

        _this.props.teamMembers.forEach(function (t) {
          var teamMemberAlreadyAssigned = false;

          _this.props.clientDetail.teamMembers.forEach(function (tm) {
            if (tm.id === t.id) {
              teamMemberAlreadyAssigned = true;
            }
          });

          if (!teamMemberAlreadyAssigned) {
            filteredTeamMemberList.push(t);
          }
        });

        clickedId = filteredTeamMemberList[selectedRow].id;
      }

      browserHistory.push({
        pathname: "/global/team/".concat(clickedId)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (key) {
      _this.setState({
        selectedTab: key
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAssign", function () {
      _this.props.assignTeamMemberToOrganization(_this.props.selectedUnassignedTeamMembers, _this.props.clientDetail.organization_id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditDetails", function () {
      var formValues = Object.assign({}, _this.state.formValues);
      formValues.address = {
        address1: formValues.address1,
        address2: formValues.address2,
        locality: formValues.locality,
        region: formValues.region,
        postcode: formValues.postcode
      };
      formValues.ownerName = {
        first: formValues.ownerFirstName,
        last: formValues.ownerLastName
      };
      delete formValues.address1;
      delete formValues.address2;
      delete formValues.locality;
      delete formValues.region;
      delete formValues.postcode;
      delete formValues.ownerFirstName;
      delete formValues.ownerLastName;

      _this.props.editClientDetail(formValues, _this.props.clientDetail.contract_id).then(function () {
        _this.loadClientDetail();

        _this.setState({
          showSnackbar: true,
          snackbarMessage: 'Business details updated',
          showBusinessModal: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFormFieldChange", function (field, val) {
      _this.setState({
        formValues: _objectSpread(_objectSpread({}, _this.state.formValues), {}, _defineProperty({}, field, val))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnassign", function () {
      _this.props.unassignTeamMemberFromOrganization(_this.props.selectedAssignedTeamMembers, _this.props.clientDetail.organization_id, 'client_detail');
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      if (_this.state.selectedTeamMemberView === 'assignedTeamMembers') {
        _this.props.toggleAllSelected(_this.props.clientDetail.teamMembers.filter(_this.filterToActive).map(function (c) {
          return c.id;
        }), 'selectedAssignedTeamMembers');
      } else if (_this.state.selectedTeamMemberView === 'unassignedTeamMembers') {
        var filteredTeamMemberList = [];

        _this.props.teamMembers.filter(_this.filterToActive).forEach(function (t) {
          var teamMemberAlreadyAssigned = false;

          _this.props.clientDetail.teamMembers.filter(_this.filterToActive).forEach(function (tm) {
            if (tm.id === t.id) {
              teamMemberAlreadyAssigned = true;
            }
          });

          if (!teamMemberAlreadyAssigned) {
            filteredTeamMemberList.push(t);
          }
        });

        _this.props.toggleAllSelected(filteredTeamMemberList.map(function (c) {
          return c.id;
        }), 'selectedUnassignedTeamMembers');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleViewInvoice", function (invoice) {
      _this.setState({
        showInvoiceModal: true,
        invoice: invoice
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkAdAccountStatus", function (details) {
      var fbPage = details.SocialAccounts.filter(function (a) {
        return a.platform === 'Facebook page';
      });

      if (!fbPage) {
        return {
          status: false
        };
      } else if (fbPage.length && fbPage[0].hasOwnProperty('FacebookAdAccount')) {
        return {
          status: true,
          socialAccount: fbPage[0]
        };
      }

      return {
        status: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "filterToActive", function (tm) {
      var status;

      if (tm.UserOrganizations) {
        tm.UserOrganizations.forEach(function (uo) {
          if (uo.OrganizationId.toString() === _this.props.clientId.toString() || uo.OrganizationId.toString() === _this.props.partnerDetails.contract.OrganizationId.toString()) {
            status = uo.status;
          }
        });
      }

      if (status === 'ACTIVE' || status === 'PENDING') {
        return tm;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatPhone", function (s) {
      var s2 = "".concat(s).replace(/\D/g, '');
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? null : "(".concat(m[1], ") ").concat(m[2], "-").concat(m[3]);
    });

    _defineProperty(_assertThisInitialized(_this), "formatQueueChannels", function (queues) {
      if (!queues || !queues.length) {
        return 'No Queues';
      }

      return queues.map(function (q) {
        return q.name;
      }).join(', ');
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format);

    _defineProperty(_assertThisInitialized(_this), "getOrganizationType", function (details) {
      return {
        0: {
          id: 0,
          name: 'Multi-Location SMB'
        },
        1: {
          id: 1,
          name: 'Likeable Local'
        },
        2: {
          id: 2,
          name: 'Partner'
        },
        3: {
          id: 3,
          name: 'SMB'
        }
      }["".concat(details.organization_organizationTypeId)];
    });

    _defineProperty(_assertThisInitialized(_this), "loadClientDetail", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _contract$ContactPref, _clientData$name, _contract$firstName, _contract$lastName, _contract$email, _contract$phone, _contractContact$Addr, _contractContact$Addr2, _contract$Address$add, _contract$Address, _contractContact$Addr3, _contractContact$Addr4, _contract$Address$add2, _contract$Address2, _contractContact$Addr5, _contractContact$Addr6, _contract$Address$loc, _contract$Address3, _contractContact$Addr7, _contractContact$Addr8, _contract$Address$reg, _contract$Address4, _contractContact$Addr9, _contractContact$Addr10, _contract$Address$pos, _contract$Address5, _yield$_this$props$ge, clientData, contract, contractContact, fbPage, res, targetWhitelabelOrgId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.props.getClient(_this.props.clientId);

            case 3:
              _yield$_this$props$ge = _context.sent;
              clientData = _yield$_this$props$ge.data.Organization;

              if (clientData) {
                _context.next = 7;
                break;
              }

              throw new Error('Failed to load client');

            case 7:
              contract = clientData.Contracts && clientData.Contracts.length > 0 ? clientData.Contracts[0] : {};
              contractContact = contract === null || contract === void 0 ? void 0 : (_contract$ContactPref = contract.ContactPreferences) === null || _contract$ContactPref === void 0 ? void 0 : _contract$ContactPref[0];
              _context.prev = 9;

              if (!(clientData.SocialAccounts && clientData.SocialAccounts.length > 0)) {
                _context.next = 17;
                break;
              }

              fbPage = clientData.SocialAccounts.find(function (sa) {
                return sa.platform === 'Facebook page';
              });

              if (!(fbPage && !fbPage.valid)) {
                _context.next = 17;
                break;
              }

              _context.next = 15;
              return _this.props.refreshFacebookToken(clientData.id, fbPage.id);

            case 15:
              res = _context.sent;

              if (res.data.valid) {
                location.reload();
              }

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](9);
              console.error(_context.t0);

            case 22:
              targetWhitelabelOrgId = clientData.parentOrganizationId !== null ? clientData.parentOrganizationId : _this.props.clientId;

              _this.props.getPartnerDetailsByPartnerOrgId(targetWhitelabelOrgId);

              if (!_this.props.whiteLabelById[targetWhitelabelOrgId]) {
                _this.props.getWhitelabelInfo(targetWhitelabelOrgId);
              }

              _this.setState({
                formValues: {
                  organizationName: (_clientData$name = clientData.name) !== null && _clientData$name !== void 0 ? _clientData$name : '',
                  ownerFirstName: contractContact !== null && contractContact !== void 0 && contractContact.firstName ? contractContact.firstName : (_contract$firstName = contract.firstName) !== null && _contract$firstName !== void 0 ? _contract$firstName : '',
                  ownerLastName: contractContact !== null && contractContact !== void 0 && contractContact.lastName ? contractContact.lastName : (_contract$lastName = contract.lastName) !== null && _contract$lastName !== void 0 ? _contract$lastName : '',
                  email: contractContact !== null && contractContact !== void 0 && contractContact.email ? contractContact.email : (_contract$email = contract.email) !== null && _contract$email !== void 0 ? _contract$email : '',
                  phone: contractContact !== null && contractContact !== void 0 && contractContact.phone ? contractContact.phone : (_contract$phone = contract.phone) !== null && _contract$phone !== void 0 ? _contract$phone : '',
                  address1: contractContact !== null && contractContact !== void 0 && (_contractContact$Addr = contractContact.Address) !== null && _contractContact$Addr !== void 0 && _contractContact$Addr.address1 ? contractContact === null || contractContact === void 0 ? void 0 : (_contractContact$Addr2 = contractContact.Address) === null || _contractContact$Addr2 === void 0 ? void 0 : _contractContact$Addr2.address1 : (_contract$Address$add = contract === null || contract === void 0 ? void 0 : (_contract$Address = contract.Address) === null || _contract$Address === void 0 ? void 0 : _contract$Address.address1) !== null && _contract$Address$add !== void 0 ? _contract$Address$add : '',
                  address2: contractContact !== null && contractContact !== void 0 && (_contractContact$Addr3 = contractContact.Address) !== null && _contractContact$Addr3 !== void 0 && _contractContact$Addr3.address2 ? contractContact === null || contractContact === void 0 ? void 0 : (_contractContact$Addr4 = contractContact.Address) === null || _contractContact$Addr4 === void 0 ? void 0 : _contractContact$Addr4.address2 : (_contract$Address$add2 = contract === null || contract === void 0 ? void 0 : (_contract$Address2 = contract.Address) === null || _contract$Address2 === void 0 ? void 0 : _contract$Address2.address2) !== null && _contract$Address$add2 !== void 0 ? _contract$Address$add2 : '',
                  locality: contractContact !== null && contractContact !== void 0 && (_contractContact$Addr5 = contractContact.Address) !== null && _contractContact$Addr5 !== void 0 && _contractContact$Addr5.locality ? contractContact === null || contractContact === void 0 ? void 0 : (_contractContact$Addr6 = contractContact.Address) === null || _contractContact$Addr6 === void 0 ? void 0 : _contractContact$Addr6.locality : (_contract$Address$loc = contract === null || contract === void 0 ? void 0 : (_contract$Address3 = contract.Address) === null || _contract$Address3 === void 0 ? void 0 : _contract$Address3.locality) !== null && _contract$Address$loc !== void 0 ? _contract$Address$loc : '',
                  region: contractContact !== null && contractContact !== void 0 && (_contractContact$Addr7 = contractContact.Address) !== null && _contractContact$Addr7 !== void 0 && _contractContact$Addr7.region ? contractContact === null || contractContact === void 0 ? void 0 : (_contractContact$Addr8 = contractContact.Address) === null || _contractContact$Addr8 === void 0 ? void 0 : _contractContact$Addr8.region : (_contract$Address$reg = contract === null || contract === void 0 ? void 0 : (_contract$Address4 = contract.Address) === null || _contract$Address4 === void 0 ? void 0 : _contract$Address4.region) !== null && _contract$Address$reg !== void 0 ? _contract$Address$reg : '',
                  postcode: contractContact !== null && contractContact !== void 0 && (_contractContact$Addr9 = contractContact.Address) !== null && _contractContact$Addr9 !== void 0 && _contractContact$Addr9.postcode ? contractContact === null || contractContact === void 0 ? void 0 : (_contractContact$Addr10 = contractContact.Address) === null || _contractContact$Addr10 === void 0 ? void 0 : _contractContact$Addr10.postcode : (_contract$Address$pos = contract === null || contract === void 0 ? void 0 : (_contract$Address5 = contract.Address) === null || _contract$Address5 === void 0 ? void 0 : _contract$Address5.postcode) !== null && _contract$Address$pos !== void 0 ? _contract$Address$pos : ''
                }
              });

              _context.next = 31;
              break;

            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](0);
              console.error(_context.t1);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 28], [9, 19]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "findPaidThroughDate", function () {
      if (_this.props.clientDetail && _this.props.clientDetail.organization_paidToDate) {
        return moment(Number(_this.props.clientDetail.organization_paidToDate)).format('MM/DD/YYYY');
      }

      var paidThrough = moment();
      var foundOne = false;
      var i = _this.props.billingHistory.length - 1;

      if (_this.props.billingHistory.length === 0) {
        return paidThrough.format('MM/DD/YYYY');
      }

      while (i >= 0) {
        if (!_this.props.billingHistory[i].oneTimeCharge) {
          paidThrough = _this.props.billingHistory[i].invoiceEndDate;
          foundOne = true;
          break;
        }

        i--;
      }

      return foundOne ? paidThrough : paidThrough.format('MM/DD/YYYY');
    });

    _defineProperty(_assertThisInitialized(_this), "renderBottomContent", function (details) {
      var orgType = _this.getOrganizationType(details);

      if (_this.state.selectedTab === 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.bottomContentWrap
        }, /*#__PURE__*/React.createElement(BillingHistoryTable, {
          isScheinClient: details.paymentMethod_name && details.paymentMethod_name === 'henry schein',
          orgId: parseInt(details.organization_id),
          handleView: _this.handleViewInvoice
        }));
      }

      if (!details) return null;

      if (_this.state.selectedTab === 3) {
        var totals = _this.props.partnerDetails && _this.props.orgBillingConfig ? tallyClientTotals(_this.props.partnerDetails, _this.props.orgBillingConfig) : {};
        return /*#__PURE__*/React.createElement("div", {
          className: styles.bottomContentWrap
        }, /*#__PURE__*/React.createElement("h2", {
          className: styles.header
        }, "Monthly Billing Summary"), _this.props.clientDetail.partnerSubtype === 'multilocation' ? /*#__PURE__*/React.createElement(NewLocationSummary, {
          clientDetailView: true,
          clientDetails: details,
          contractInfo: _this.props.partnerDetails,
          style: {
            marginTop: 24
          },
          orgConfig: _this.props.orgBillingConfig,
          totals: totals
        }) : /*#__PURE__*/React.createElement(NewClientSummary, {
          contractInfo: _this.props.partnerDetails,
          style: {
            marginTop: 24
          },
          orgConfig: _this.props.orgBillingConfig,
          totals: totals,
          isClientDetail: true,
          partnerSubtype: _this.props.clientDetail.partnerSubtype
        }));
      } else if (_this.state.selectedTab === 4) {
        var facebookPage = details.SocialAccounts.find(function (sa) {
          return sa.platform === 'Facebook page';
        });
        return /*#__PURE__*/React.createElement("div", {
          className: styles.bottomContentWrap
        }, /*#__PURE__*/React.createElement(AdminFacebookPageManager, {
          connectedPage: facebookPage,
          orgId: details.organization_id
        }));
      } else if (_this.state.selectedTab === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.bottomContentWrap
        }, /*#__PURE__*/React.createElement(ClientDetailReportList, {
          orgId: details.organization_id,
          orgName: details.organization_name
        }));
      } else if (_this.state.selectedTab === 5) {
        return /*#__PURE__*/React.createElement(TeamNotificationTab, {
          clientId: details.organization_id
        });
      } else if (_this.state.selectedTab === 6) {
        var userType = 'likeablelocal';

        if (!_this.props.user.isLikeableLocal && _this.props.user.isPartner) {
          userType = 'partner';
        }

        var availableFeatures = _this.props.clientDetail.availableFeatures;
        return /*#__PURE__*/React.createElement("div", null, "No feature settings at this time");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSocialAccounts", function (details) {
      if (!details) {
        return null;
      }

      var sa = details.SocialAccounts;

      if (!sa || !sa.length) {
        return /*#__PURE__*/React.createElement("h6", {
          className: styles.detail
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.detailName
        }, "No Accounts"));
      }

      var icon = /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-checkmark",
        style: {
          color: 'green'
        }
      });
      return sa.sort(function (a, b) {
        if (a.platform < b.platform) {
          return -1;
        }

        if (a.platform > b.platform) {
          return 1;
        }

        return 0;
      }).map(function (a, index) {
        if (a.platform === 'Facebook page') {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, "Facebook Page:"), " ", a.username);
        } else if (a.platform === 'Twitter') {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, "Twitter:"), " @", a.username);
        } else if (a.platform.indexOf('Instagram[page_connected]') === 0) {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, "Instagram (page connected):"), " ", a.username);
        } else if (a.platform.indexOf('Instagram') === 0) {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, "Instagram:"), " ", a.username);
        } else if (a.platform.indexOf('LinkedIn profile') === 0) {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, a.platform, ":"), " ", a.username);
        } else if (a.platform.indexOf('LinkedIn company') === 0) {
          if (!a.valid) {
            icon = /*#__PURE__*/React.createElement("i", {
              className: "icon ion-ios-close",
              style: {
                color: 'red'
              }
            });
          }

          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, a.platform, ":"), " ", a.username);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDetails", function (fields, details) {
      return fields.map(function (f, index) {
        if (details[f.key] && details[f.key] !== '') {
          return /*#__PURE__*/React.createElement("h6", {
            key: index,
            className: styles.detail,
            id: "test-businessdetailsfield-".concat(f.key)
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.detailName
          }, f.name, ":"), " ", details[f.key]);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInnerStuff", function (haveRightDetails, details) {
      var _this$props, _this$props$selectedO, _this$props$selectedO2, _this$props$orgBillin, _this$props$orgBillin2, _this$props$orgBillin3, _this$props$orgBillin4, _this$props$orgBillin5, _this$props$orgBillin6, _this$props$orgBillin7, _this$props$orgBillin8, _this$props$orgBillin9, _this$props$orgBillin10;

      if (!_this.props.partnerDetails) {
        return false;
      }

      var isPartnersOwnDetailPage = parseInt(_this.props.theme.org) === parseInt(_this.props.clientId);
      var hasPlan = _this.props.billingHistory && _this.props.billingHistory.findIndex(function (e) {
        return !!e.lineItems.length;
      }) !== -1;
      var heartbeatData = _this.props.heartbeat ? _this.props.heartbeat[_this.props.clientId] : null;

      if (haveRightDetails) {
        details.owner_name = details.contract_firstName || details.contract_lastName ? "".concat(details.contract_firstName, " ").concat(details.contract_lastName) : '';
        details.location = details.address_locality || details.address_region ? "".concat(details.address_locality, ", ").concat(details.address_region) : '';
        details.plan = "".concat(details.product_title, " / $").concat(details.contractProduct_monthlyFee, " per Month");
        details.startDate = moment(Number(details.organization_createdAt)).format('M/D/YYYY');
        details.phone = _this.formatPhone(details.contract_phone);
        details.queueChannels = _this.formatQueueChannels(details.queue_names);
        details.fbad_formattedMonthlySpend = "$".concat(details.fbad_monthSpend);
        details.paymentName = details.paymentMethod_name ? _.startCase(details.paymentMethod_name) : 'None';
        details.fbAdAccountStatus = _this.checkAdAccountStatus(details).status ? /*#__PURE__*/React.createElement("span", {
          className: styles.detailName
        }, "Active ", /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-checkmark",
          style: {
            color: 'green'
          }
        })) : /*#__PURE__*/React.createElement("span", {
          className: styles.detailName
        }, "Inactive ", /*#__PURE__*/React.createElement("i", {
          className: "icon ion-ios-close",
          style: {
            color: 'red'
          }
        }));
        details.fbadAccountSocialAccount = _this.checkAdAccountStatus(details).socialAccount;
      }

      var businessFields = [{
        name: 'Created',
        key: 'startDate'
      }, {
        name: 'Owner',
        key: 'owner_name'
      }, {
        name: 'Location',
        key: 'location'
      }, {
        name: 'Email',
        key: 'contract_email'
      }, {
        name: 'Phone',
        key: 'contract_phone'
      }, {
        name: 'Organization ID',
        key: 'organization_id'
      }];

      if (details.partnerAdsCommissionPercent) {
        details._partnerAdsCommissionPercent = Number(parseFloat(details.partnerAdsCommissionPercent) / 100.0).toLocaleString(undefined, {
          style: 'percent',
          minimumFractionDigits: 2
        });
      }

      if (details.likeableAdsCommissionPercent) {
        details._likeableAdsCommissionPercent = Number(parseFloat(details.likeableAdsCommissionPercent) / 100.0).toLocaleString(undefined, {
          style: 'percent',
          minimumFractionDigits: 2
        });
      }

      var advertisingFields = [{
        name: 'Status',
        key: 'fbAdAccountStatus'
      }, {
        name: 'Partner Ads Commission',
        key: '_partnerAdsCommissionPercent'
      }, {
        name: 'Likeable Ads Commission',
        key: '_likeableAdsCommissionPercent'
      }];
      var messageFields = [{
        name: 'Awaiting Response',
        key: 'newMessages'
      }];
      var contentFields = [{
        name: 'Queues',
        key: 'queueChannels'
      }, {
        name: 'Queued Items',
        key: 'queue_contentCount'
      }];

      if (_this.props.heartbeat) {
        var _heartbeatData$deposi, _heartbeatData$pendin, _heartbeatData$availa;

        details.heartbeatTotalDeposits = _this.formatCurrency(((_heartbeatData$deposi = heartbeatData === null || heartbeatData === void 0 ? void 0 : heartbeatData.deposits) !== null && _heartbeatData$deposi !== void 0 ? _heartbeatData$deposi : 0) / 100.0);
        advertisingFields.push({
          name: 'Total Deposits',
          key: 'heartbeatTotalDeposits'
        }); // Display "Pending" spend as "Spent" until we make a system to populate "Spent" dollars

        details.heartbeatTotalSpent = _this.formatCurrency(((_heartbeatData$pendin = heartbeatData === null || heartbeatData === void 0 ? void 0 : heartbeatData.pending) !== null && _heartbeatData$pendin !== void 0 ? _heartbeatData$pendin : 0) / 100.0);
        advertisingFields.push({
          name: 'Total Spent',
          key: 'heartbeatTotalSpent'
        });
        /* details.heartbeatTotalSpent = this.formatCurrency(heartbeatData.spent / 100.0);
        advertisingFields.push({ name: 'Total Spent', key: 'heartbeatTotalSpent' });
        details.heartbeatPending = this.formatCurrency(heartbeatData.pending / 100.0);
        advertisingFields.push({ name: 'Pending Funds', key: 'heartbeatPending' });*/

        details.heartbeatAvailable = _this.formatCurrency(((_heartbeatData$availa = heartbeatData === null || heartbeatData === void 0 ? void 0 : heartbeatData.available) !== null && _heartbeatData$availa !== void 0 ? _heartbeatData$availa : 0) / 100.0);
        advertisingFields.push({
          name: 'Available Funds',
          key: 'heartbeatAvailable'
        });
      }

      var filteredTeamMemberList = [];

      if (_this.props.teamMembers && details.teamMembers) {
        _this.props.teamMembers.filter(_this.filterToActive).forEach(function (t) {
          var teamMemberAlreadyAssigned = false;
          details.teamMembers.filter(_this.filterToActive).forEach(function (tm) {
            if (tm.id === t.id) {
              teamMemberAlreadyAssigned = true;
            }
          });

          if (!teamMemberAlreadyAssigned) {
            filteredTeamMemberList.push(t);
          }
        });
      }

      var teamMemberButtonBarTabs = [{
        title: 'Assigned',
        key: 'assignedTeamMembers'
      }, {
        title: 'Other',
        key: 'unassignedTeamMembers'
      }];
      var cancelled = details.organization_status === 'pending_cancel' || details.organization_status === 'cancelled';
      var pastGracePeriod = parseInt(details.gracePeriodState) >= 2; // look first for own whiteLabel in the case of a partner

      var whiteLabelDomain = (_this$props = _this.props) !== null && _this$props !== void 0 && (_this$props$selectedO = _this$props.selectedOrgData) !== null && _this$props$selectedO !== void 0 && (_this$props$selectedO2 = _this$props$selectedO.ownWhiteLabel) !== null && _this$props$selectedO2 !== void 0 && _this$props$selectedO2.domain ? whiteLabelDomain = _this.props.selectedOrgData.ownWhiteLabel.domain : null; // now get whiteLabelDomain from partner details if it's a partner client

      if (!whiteLabelDomain && _this.props.whiteLabelById && _this.props.whiteLabelById[_this.props.clientDetail.organization_parentOrganizationId]) {
        whiteLabelDomain = _this.props.whiteLabelById[_this.props.clientDetail.organization_parentOrganizationId].domain;
      }

      var onWhiteLabelDomain = location.href.includes(whiteLabelDomain);
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column'
        }
      }, haveRightDetails && cancelled && !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.clientCancelledBanner
      }, "The subscription for ", details.organization_name, " will end on ", _this.findPaidThroughDate(), "."), haveRightDetails && pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.clientCancelledBanner
      }, "The subscription for ", details.organization_name, " ended on ", _this.findPaidThroughDate(), "."), haveRightDetails ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px',
          minHeight: 60,
          borderBottom: '1px solid #e3e3e3'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: details.organization_name,
        style: {
          marginBottom: 16
        }
      }), !pastGracePeriod && !_this.props.isOrgClientDetailView ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginTop: 12
        },
        secondary: true,
        label: "Open In New Tab",
        onClick: function onClick() {
          return _this.handleOpenTab(_this.props.clientDetail.organization_id);
        }
      })) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(RaisedButton, {
        style: {
          marginTop: 12
        },
        secondary: true,
        label: "View Admin Area",
        labelPosition: "before",
        icon: /*#__PURE__*/React.createElement("i", {
          className: "icon ion-arrow-right-c",
          style: {
            color: 'white',
            fontSize: 20
          }
        }),
        onClick: function onClick() {
          browserHistory.push('/global');
        }
      }))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          overflowY: 'scroll'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, haveRightDetails ? /*#__PURE__*/React.createElement("div", {
        className: styles.columnWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, " Business Details "), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, haveRightDetails && _this.renderDetails(businessFields, details)), !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        id: "test_businessdetailsedit",
        className: "".concat(styles.actionAreaIcon, " fa fa-pencil"),
        onClick: _this.handleToggleBusinessModal
      })))), ((_this$props$orgBillin = _this.props.orgBillingConfig) === null || _this$props$orgBillin === void 0 ? void 0 : _this$props$orgBillin.billingMethod) === 'affiliate' && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Billing Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Product Title:"), " ", details.product_title), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Monthly Price:"), ' ', _this.formatCurrency(details.contractProduct_monthlyFee)), /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Ads Budget:"), ' ', _this.formatCurrency(details.contractProduct_monthlyAdsBudget))), !isPartnersOwnDetailPage && !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.actionAreaIcon, " fa fa-pencil"),
        onClick: _this.handleToggleBillingModal
      })))), ((_this$props$orgBillin2 = _this.props.orgBillingConfig) === null || _this$props$orgBillin2 === void 0 ? void 0 : _this$props$orgBillin2.billingMethod) !== 'affiliate' && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, _.startCase((_this$props$orgBillin3 = _this.props.orgBillingConfig) === null || _this$props$orgBillin3 === void 0 ? void 0 : _this$props$orgBillin3.billingMethod), " Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Type:"), ' ', _this.props.orgBillingConfig && (_this$props$orgBillin4 = _this.props.orgBillingConfig) !== null && _this$props$orgBillin4 !== void 0 && _this$props$orgBillin4.billingMethod ? "".concat(_.startCase((_this$props$orgBillin5 = _this.props.orgBillingConfig) === null || _this$props$orgBillin5 === void 0 ? void 0 : _this$props$orgBillin5.billingMethod)) : 'Unknown'), _this.props.orgBillingConfig && ((_this$props$orgBillin6 = _this.props.orgBillingConfig) === null || _this$props$orgBillin6 === void 0 ? void 0 : _this$props$orgBillin6.billingMethod) && ((_this$props$orgBillin7 = _this.props.orgBillingConfig) === null || _this$props$orgBillin7 === void 0 ? void 0 : _this$props$orgBillin7.billingMethod) === 'likeable_partner' && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, "Partner Subtype: ", details.partnerSubtype ? _.startCase(details.partnerSubtype) : 'Regular', ' '), hasPlan && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Paid Through:"), " ", _this.findPaidThroughDate()), _this.props.hasAdPaymentMethod ? /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Ads Payment Method:"), ' ', _this.props.cc ? "".concat(_this.props.cc.brand, " Ending in ").concat(_this.props.cc.last4) : null) : null, _this.props.orgBillingConfig && !['likeable_smb', 'license', 'likeable_partner'].includes((_this$props$orgBillin8 = _this.props.orgBillingConfig) === null || _this$props$orgBillin8 === void 0 ? void 0 : _this$props$orgBillin8.billingMethod) && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Managed By:"), ' ', _this.props.orgBillingConfig.managementMethod === 'partnerManaged' ? _this.props.partnerDetails.contract.businessName : 'Likeable Local', ' ', "- $", _this.props.orgBillingConfig.managementMethod === 'partnerManaged' ? _this.props.partnerDetails.terms.partnerManagedMonthlyFee : _this.props.partnerDetails.terms.llManagedMonthlyFee, "/mo"), _this.props.orgBillingConfig && ((_this$props$orgBillin9 = _this.props.orgBillingConfig) === null || _this$props$orgBillin9 === void 0 ? void 0 : _this$props$orgBillin9.billingMethod) === 'end_to_end' && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Management Fee:"), " $", _this.props.orgBillingConfig.managementFee, "/mo"), hasPlan && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Monthly Ads Budget:"), ' ', _this.props.orgBillingConfig ? _this.formatCurrency(_this.props.orgBillingConfig.adsBudget) : 'Unknown')), (_this.props.user.isLikeableLocal || !isPartnersOwnDetailPage) && !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        id: "test_billingmodaledit",
        className: "".concat(styles.actionAreaIcon, " fa fa-pencil"),
        onClick: _this.handleToggleBillingModal
      })))), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Social Accounts"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, haveRightDetails && _this.renderSocialAccounts(details)), !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.actionAreaIcon, " fa fa-external-link"),
        onClick: function onClick() {
          return _this.handleOpenTab(_this.props.clientDetail.organization_id, 'settings/social-accounts');
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Advertising"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, haveRightDetails && _this.renderDetails(advertisingFields, details), hasPlan && /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Monthly Ads Budget:"), ' ', _this.props.orgBillingConfig ? _this.formatCurrency(_this.props.orgBillingConfig.adsBudget) : 'Unknown')), !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.actionAreaIcon, " fa fa-external-link"),
        onClick: function onClick() {
          return _this.handleOpenTab(_this.props.clientDetail.organization_id, 'ads');
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Content"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, haveRightDetails && _this.renderDetails(contentFields, details)), !pastGracePeriod && /*#__PURE__*/React.createElement("div", {
        className: styles.actionArea
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.actionAreaInner
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.actionAreaIcon, " fa fa-external-link"),
        onClick: function onClick() {
          return _this.handleOpenTab(_this.props.clientDetail.organization_id, 'content');
        }
      })))), _this.props.user.isLikeableLocal && whiteLabelDomain && !onWhiteLabelDomain && /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Partner Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Domain:"), ' ', /*#__PURE__*/React.createElement("a", {
        href: "//".concat(whiteLabelDomain),
        target: "_blank"
      }, whiteLabelDomain)))), _this.props.user.isLikeableLocal && _this.props.clientDetail.organization_parentOrganizationId > 0 ? null : /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.header
      }, "Agreement Details"), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsWrap
      }, /*#__PURE__*/React.createElement("h6", {
        className: styles.detail
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.detailName
      }, "Agreement:"), ' ', /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'blue',
          cursor: 'pointer',
          textDecoration: 'underline'
        },
        onClick: function onClick() {
          browserHistory.push("/global/agreements/".concat(_this.props.clientDetail.contract_uuid, "/teamview"));
        }
      }, "View Agreement"))))) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 100,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 0,
        label: 'Reports',
        key: 4,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 0),
        style: {
          padding: '5px 16px'
        }
      }), /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 1,
        label: 'Billing History',
        key: 0,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 1),
        style: {
          padding: '5px 16px'
        }
      }), _this.props.clientDetail && _this.props.orgBillingConfig && ((_this$props$orgBillin10 = _this.props.orgBillingConfig) === null || _this$props$orgBillin10 === void 0 ? void 0 : _this$props$orgBillin10.billingMethod) !== 'likeable_smb' && /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 3,
        label: 'Billing Summary',
        key: 2,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 3),
        style: {
          padding: '5px 16px'
        }
      }), (_this.props.user.isLikeableLocal || _this.props.user.isPartner) && /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 6,
        label: 'Feature Settings',
        key: 6,
        onClick: function onClick() {
          _this.handleTabClick(6);
        },
        style: {
          padding: '5px 16px'
        }
      }), _this.props.user.isLikeableLocal && /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 4,
        label: 'Facebook Page Manager',
        key: 3,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 4),
        style: {
          padding: '5px 16px'
        }
      }), _this.props.user.isLikeableLocal && /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 5,
        label: /*#__PURE__*/React.createElement("span", null, "Team Notifications", _this.state.teamNotificationSubs.length === 0 && /*#__PURE__*/React.createElement("i", {
          style: {
            marginLeft: 6,
            color: 'darkred'
          },
          className: "icon ion-alert-circled"
        })),
        key: 5,
        onClick: function onClick() {
          _this.handleTabClick(5);
        },
        style: {
          padding: '5px 16px'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, _this.state.selectedTab === 2 && details.teamMembers && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        selected: _this.state.selectedTeamMemberView,
        items: teamMemberButtonBarTabs,
        onChange: _this.handleTeamMemberButtonBarChange
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.controlBarWrap,
        style: {
          marginTop: 24
        }
      }, /*#__PURE__*/React.createElement(ControlBar, null, /*#__PURE__*/React.createElement(Control, {
        type: "checkbox",
        onClick: _this.handleSelectAll,
        innerStyle: {
          padding: '0 13px'
        }
      }), _this.props.selectedAssignedTeamMembers && _this.props.selectedAssignedTeamMembers.length && _this.state.selectedTeamMemberView === 'assignedTeamMembers' ? /*#__PURE__*/React.createElement(Control, {
        text: "Unassign",
        onClick: _this.handleUnassign,
        disabled: _this.props.isUnassigning
      }) : null, _this.props.selectedUnassignedTeamMembers && _this.props.selectedUnassignedTeamMembers.length && _this.state.selectedTeamMemberView === 'unassignedTeamMembers' ? /*#__PURE__*/React.createElement(Control, {
        text: "Assign",
        onClick: _this.handleAssign,
        disabled: _this.props.isAssigning
      }) : null))), _this.renderBottomContent(details)))));
    });

    var _c = props.clientDetails;
    _this.state = {
      selectedTab: 0,
      showBusinessModal: false,
      showBillingModal: false,
      selectedTeamMemberView: 'assignedTeamMembers',
      showInvoiceModal: false,
      invoice: false,
      showSnackbar: false,
      snackbarMessage: '',
      teamNotifications: [],
      loadingTeamNotifications: false,
      teamNotificationSubs: [],
      loadingClientError: null
    };
    return _this;
  }

  _createClass(ClientDetail, [{
    key: "componentDidMount",
    value:
    /** *********************************************************
     LIFECYCLE METHODS
     ***********************************************************/
    function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var initialActions, results, _results$find, _results$find2, msg;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.loadClientDetail();

              case 3:
                initialActions = [function () {
                  return _this2.props.getTeamMembers(_this2.props.clientId);
                }, function () {
                  return _this2.props.getAdsPaymentMethod(_this2.props.clientId);
                }, function () {
                  return _this2.props.getAdSpendSummaryForOrganization(_this2.props.clientId);
                }, function () {
                  return _this2.props.getOrgBillingConfig(_this2.props.clientId);
                }, function () {
                  return _this2.props.getBillingHistory(_this2.props.clientId);
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var _yield$_this2$props$g, data;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2.props.getOrgNotificationSubscriptions(_this2.props.clientId);

                        case 2:
                          _yield$_this2$props$g = _context2.sent;
                          data = _yield$_this2$props$g.data;

                          _this2.setState({
                            teamNotificationSubs: data
                          });

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }))];
                _context4.next = 6;
                return Promise.all(initialActions.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fn) {
                    var _err$error;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return fn();

                          case 3:
                            return _context3.abrupt("return", [true]);

                          case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3["catch"](0);
                            console.error(_context3.t0);
                            return _context3.abrupt("return", [false, (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_err$error = _context3.t0.error) === null || _err$error === void 0 ? void 0 : _err$error.message) || _context3.t0.message]);

                          case 10:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[0, 6]]);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 6:
                results = _context4.sent;

                if (results.every(function (_ref4) {
                  var _ref5 = _slicedToArray(_ref4, 1),
                      isOk = _ref5[0];

                  return isOk === false;
                })) {
                  // All Failed
                  console.error('Failed all initial actions load');
                  _results$find = results.find(function (r) {
                    return r[0] === false;
                  }), _results$find2 = _slicedToArray(_results$find, 2), msg = _results$find2[1];
                  this.setState({
                    loadingClientError: msg || 'Failed to load this client.'
                  });
                }

                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                console.error(_context4.t0);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearOrgBillingConfig();
      this.props.clearCreditCardInfo();
    }
    /** *********************************************************
     EVENT HANDLER METHODS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props$orgBillin11,
          _this3 = this;

      var haveRightDetails = false;
      var details = false;
      var hasPlan = this.props.billingHistory && this.props.billingHistory.findIndex(function (e) {
        return !!e.lineItems.length;
      }) !== -1;

      if (this.props.clientDetail) {
        // Redux store may have a clientDetail already - confirm that we have the details for the current org
        haveRightDetails = this.props.clientDetail.organization_id == this.props.clientId;

        if (haveRightDetails) {
          details = _objectSpread({}, this.props.clientDetail);

          if (this.props.clientDetail.contract_overrides && Object.keys(this.props.clientDetail.contract_overrides).length > 0) {
            details = _objectSpread(_objectSpread({}, details), this.props.clientDetail.contract_overrides);
          }
        }
      }

      var isPendingAffiliateClient = details && details.organization_status === 'pending' && ((_this$props$orgBillin11 = this.props.orgBillingConfig) === null || _this$props$orgBillin11 === void 0 ? void 0 : _this$props$orgBillin11.billingMethod) === 'affiliate'; // TODO either adjust this logic, or remove if pending is still the way to tell for sure
      // needs to use paidThrough here -- at the moment, if contract_paymentDetailEntryType === 1
      // it lets them right through to Client Detail view
      //    const isAffiliateClientNeedingPayment = details && details.contract_paymentDetailEntryType === 2;

      if (isPendingAffiliateClient) {
        return /*#__PURE__*/React.createElement(PendingAffiliateClient, {
          details: details
        });
      }

      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      var wrapStyle = {
        flex: '1 1 auto',
        paddingBottom: 36,
        minWidth: 1010
      };
      var businessModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: this.handleToggleBusinessModal,
        style: {
          marginRight: 16
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: this.props.editingClient,
        label: "Save",
        onClick: this.handleEditDetails
      })];
      var billingModalActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Close",
        onClick: this.handleToggleBillingModal
      })];
      return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrap,
          style: _this3.props.style
        }, details ? _this3.renderInnerStuff(haveRightDetails, details) : !_this3.props.loadingClientErrorMessage && !_this3.state.loadingClientError ? /*#__PURE__*/React.createElement("div", {
          style: {
            flex: '0 0 100%',
            height: 100,
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        })) : /*#__PURE__*/React.createElement("div", {
          style: {
            flex: '0 0 100%',
            height: 100,
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center',
            color: '#cc1818'
          }
        }, _this3.props.loadingClientErrorMessage || _this3.state.loadingClientError)), _this3.props.billingHistory && /*#__PURE__*/React.createElement(Dialog, {
          title: _this3.state.invoice && !_this3.state.invoice.oneTimeCharge ? "Invoice ".concat(_this3.state.invoice.invoiceStartDate, " - ").concat(_this3.state.invoice.invoiceEndDate) : "Invoice ".concat(_this3.state.invoice.createdDate),
          autoScrollBodyContent: true,
          open: _this3.state.showInvoiceModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showInvoiceModal: false
            });
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(Invoice, {
          invoice: _objectSpread(_objectSpread({}, _this3.state.invoice), {}, {
            orgId: parseInt(details.organization_id, 10),
            orgTypeId: details.organization_organizationTypeId
          })
        }))), /*#__PURE__*/React.createElement(Dialog, {
          title: "Edit ".concat(details.organization_name, " Details"),
          autoScrollBodyContent: true,
          open: _this3.state.showBusinessModal,
          onRequestClose: _this3.handleToggleBusinessModal,
          actions: businessModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(ClientDetailForm, {
          formValues: _this3.state.formValues,
          handleFormFieldChange: _this3.handleFormFieldChange
        }))), /*#__PURE__*/React.createElement(Dialog, {
          title: "Billing Details",
          autoScrollBodyContent: true,
          open: _this3.state.showBillingModal,
          onRequestClose: _this3.handleToggleBillingModal,
          actions: billingModalActions,
          actionsContainerStyle: {
            padding: 12
          },
          titleStyle: {
            color: _this3.props.theme.colors.black2
          }
        }, _this3.props.partnerDetails && /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(BillingDetail, {
          cc: _this3.props.cc,
          orgBillingConfig: _this3.props.orgBillingConfig,
          partnerDetails: _this3.props.partnerDetails,
          clientDetails: details,
          paidThroughDate: _this3.findPaidThroughDate(),
          closeParentModal: function closeParentModal() {
            var snackbarMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (snackbarMessage) {
              _this3.setState({
                showBillingModal: false,
                snackbarMessage: snackbarMessage,
                showSnackbar: true
              });
            } else {
              _this3.setState({
                showBillingModal: false
              });
            }
          }
        }))), /*#__PURE__*/React.createElement(Snackbar, {
          contentStyle: {
            textAlign: 'center'
          },
          open: _this3.state.showSnackbar,
          message: _this3.state.snackbarMessage,
          autoHideDuration: 4000,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showSnackbar: false,
              snackbarMessage: ''
            });
          }
        }));
      });
    }
  }]);

  return ClientDetail;
}(Component), _defineProperty(_class2, "propTypes", {
  theme: PropTypes.object.isRequired,
  clientDetail: PropTypes.any,
  isLoadingTeamMembers: PropTypes.any,
  teamMembers: PropTypes.array,
  selectedAssignedTeamMembers: PropTypes.array,
  selectedUnassignedTeamMembers: PropTypes.array,
  deselectItem: PropTypes.func,
  selectItem: PropTypes.func,
  getClient: PropTypes.func,
  getTeamMembers: PropTypes.func
}), _defineProperty(_class2, "defaultProps", {
  clientDetail: null,
  style: {}
}), _temp)) || _class);
export default ClientDetail;